// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y47G2WzzjyQgIUl0S8Tb{border:1px solid var(--border-neutral-default);cursor:pointer;border-radius:6px;align-items:center;width:100%;height:44px;display:flex}.Ki6GYFbMa_QvkichF0rW{border-color:var(--border-brand-default);background:var(--light-blue-10)}.pMW928RFLb0Cbmg0Nrgs{margin:0 12px}.OrklAUXZYyUGpjVCbdOZ{flex:1;min-width:0;margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `y47G2WzzjyQgIUl0S8Tb`,
	"rowSelected": `Ki6GYFbMa_QvkichF0rW`,
	"checkbox": `pMW928RFLb0Cbmg0Nrgs`,
	"label": `OrklAUXZYyUGpjVCbdOZ`
};
export default ___CSS_LOADER_EXPORT___;
